import { x as m, c as h } from "../lit-element-8JrrHldg.js";
import { n as p } from "../property-4FoNj0Pi.js";
import { o as f } from "../if-defined-Cd-e8xtV.js";
import { P as _ } from "../pwc-element-CZs0VuUW.js";
import { p as c } from "../pwcProperty-CTLG9yrF.js";
var u = Object.defineProperty, v = Object.getOwnPropertyDescriptor, e = (g, r, s, l) => {
  for (var o = l > 1 ? void 0 : l ? v(r, s) : r, i = g.length - 1, a; i >= 0; i--)
    (a = g[i]) && (o = (l ? a(r, s, o) : a(o)) || o);
  return l && o && u(r, s, o), o;
};
const n = "pwc-header", d = "https://cdn.ecoonline.com/assets/logos";
let t = class extends _ {
  render() {
    return m`
      <div class="PwcHeader">
        <a
          class="PwcHeader__logo"
          href=${f(this.logoUrl)}
          title=${this.logoTitle}
          @click=${this.logoClickHandler}
        >
          <img class="PwcHeader__logo--text" src="${this.logoWithText}" />
          <img class="PwcHeader__logo--noText" src="${this.logoNoText}" />
        </a>
        <div class="PwcHeader__navigation">
          <p-slot .host=${this}></p-slot>
        </div>
      </div>
    `;
  }
};
t.tagName = n;
e([
  p({ type: String, attribute: "logo-url" })
], t.prototype, "logoUrl", 2);
e([
  c({ type: String, attribute: "logo-title", default: "EcoOnline" })
], t.prototype, "logoTitle", 2);
e([
  p({ attribute: "logo-click-handler" })
], t.prototype, "logoClickHandler", 2);
e([
  c({
    type: String,
    attribute: "logo-with-text",
    default: `${d}/brand/logo.svg`
  })
], t.prototype, "logoWithText", 2);
e([
  c({
    type: String,
    attribute: "logo-no-text",
    default: `${d}/brand/logomark.svg`
  })
], t.prototype, "logoNoText", 2);
t = e([
  h(n)
], t);
export {
  t as PwcHeader,
  d as cdnLogos
};
